/* eslint-disable class-methods-use-this */
import EventClass from "common/utils/ui/event-class";

class MagnifierMouseEnterHandler extends EventClass {
  #$imageBox = undefined;

  #config = undefined;

  #backdrop = undefined;

  get #$original() {
    return this.#$imageBox.querySelector(".js-magnify-image");
  }

  get #$magnified() {
    return this.#$imageBox.querySelector(".js-magnify-preview");
  }

  get #$lens() {
    return this.#$imageBox.querySelector(".js-magnify-lens");
  }

  get #isLeftSided() {
    return this.#config.position === "left";
  }

  get #backgroundColor() {
    const { backgroundColor } = this.#$magnified.dataset;
    return backgroundColor;
  }

  get #isTransparentBackground() {
    return this.#backgroundColor === undefined || this.#backgroundColor === "transparent";
  }

  get #$panel() {
    if (this.#isLeftSided) {
      return document.querySelector(".js-info-left");
    }
    return document.querySelector(".js-info-right");
  }

  constructor({ event, eventSelector, config }) {
    super({ eventSelector, event });
    this.#$imageBox = document.querySelector(eventSelector);
    this.#config = config || {};
  }

  #setBackgroundImage() {
    const $magnified = this.#$magnified;
    // eslint-disable-next-line no-unused-vars
    const [imageSrc, transparentBg] = getComputedStyle($magnified).backgroundImage.split(", ");
    if (this.#isTransparentBackground) {
      this.#backdrop = transparentBg ?? this.#backdrop;
      this.#$magnified.style.backgroundImage = `url("${this.#$original.src}"), ${this.#backdrop}`;
      this.#$magnified.style.backgroundRepeat = "no-repeat, repeat";
      return;
    }
    this.#$magnified.style.backgroundImage = `url("${this.#$original.src}")`;
    this.#$magnified.style.backgroundColor = this.#backgroundColor;
  }

  /**
   * @returns void
   * @override EventClass.event
   * @description This method is called when the mouse moved into the image.
   */
  event() {
    if (!this.#$original) return;

    const imageBox = this.#$original.getBoundingClientRect();

    // Set the width of the magnified image to extend to edge of the right panel only in the PDP page.
    if (this.#$panel && !this.#config.isModal) {
      const panelRect = this.#$panel.getBoundingClientRect();
      this.#$magnified.style.width = this.#isLeftSided
        ? `${panelRect.width}px`
        : `${panelRect.right - imageBox.right - 10}px`;
    }

    this.#$original.style.cursor = "pointer";
    this.#$magnified.style.display = "block";

    if (this.#isLeftSided) {
      this.#$magnified.style.right = "calc(100% + 10px)";
    } else {
      this.#$magnified.style.left = `${this.#$original.offsetWidth + 10}px`;
    }

    this.#$lens.style.display = "block";

    this.#setBackgroundImage();
  }
}

export default props => new MagnifierMouseEnterHandler({ event: "mouseenter", ...props });
